export const PSCRatioBody = (value: number | undefined) => {
    if (value === undefined) {
        return null
    }

    return <p>{value}%</p>;
}